import { Button, Select, DatePicker, Row, Col } from 'antd'
import React, { useEffect, useState } from 'react'
import { SearchOutlined } from '@ant-design/icons'
import { fetchCountryProvider } from 'src/api/authen'
import { UserNameAutoComplete } from 'src/components/Search/UserNameSearch'
import { getAllGames } from 'src/api/reports'

interface TreasureRedeemReportSearchProps {
  appendSearchForm: (obj: any) => void
  submitSearchForm: () => void
}

interface Game {
  id: string
  title: string
}

const TreasureRedeemReportSearch: React.FC<TreasureRedeemReportSearchProps> = ({
  appendSearchForm,
  submitSearchForm,
}) => {
  const [searchType] = useState('Between')
  const [isCategoryMapLoading, setIsCategoryMapLoading] = useState(false)
  const [listOfGames, setListOfGames] = useState<Game[]>([])
  const [countries, setCountries] = useState<{ label: string; value: string }[]>(
    []
  )

  const handleSearchClick = () => {
    appendSearchForm({ buttonAction: ' ' })
    submitSearchForm()
  }

  const filterGameOption = (inputValue, option) => {
    return option.label.toLowerCase().includes(inputValue.toLowerCase())
  }

  useEffect(() => {
    appendSearchForm({ providerCountry: '' })
    appendSearchForm({ userName: '' })
    appendSearchForm({ gameId: '' })
    appendSearchForm({ startDate: '' })
    appendSearchForm({ endDate: '' })
  }, [searchType])

  useEffect(() => {
    const fetchGames = async () => {
      try {
        setIsCategoryMapLoading(true)
        const data = await getAllGames("treasure")
        if (data) {
          setListOfGames(data)
        }
      } catch (error) {
        console.error('Error fetching games:', error)
      } finally {
        setIsCategoryMapLoading(false)
      }
    }

    fetchGames()

    const fetchCountry = async () => {
      try {
        const data = await fetchCountryProvider()
        const countryOptions = data.data.map((item) => ({
          label: item.countryName,
          value: item.countryCode,
        }))
        setCountries(countryOptions)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchCountry()
  }, [])

  return (
    <div className="master-search-wrap">
      <Row gutter={15}>
        <Col span={4}>
          <UserNameAutoComplete appendSearchForm={appendSearchForm} />
        </Col>
        <Col span={4}>
          <Select
            placeholder="Select Game"
            onChange={(value) => appendSearchForm({ gameId: value })}
            filterOption={filterGameOption}
            allowClear
            onClear={() => appendSearchForm({ gameId: '' })}
            className="search-input"
            showSearch
            loading={isCategoryMapLoading}
          >
            {listOfGames.map((game) => (
              <Select.Option value={game.id} key={game.id} label={game.title}>
                {game.title}
              </Select.Option>
            ))}
          </Select>
        </Col>
        <Col span={4}>
          <Select
            placeholder="Provider Country"
            onChange={(value) => {
              appendSearchForm({ providerCountry: value })
              if (!value) submitSearchForm()
            }}
            allowClear
            onClear={() => {
              appendSearchForm({ providerCountry: '' })
              submitSearchForm()
            }}
            showSearch
            className="search-input"
            style={{ width: '100%' }}
          >
            {countries.map((country) => (
              <Select.Option value={country.value} key={country.value}>
                {country.label}
              </Select.Option>
            ))}
          </Select>
        </Col>
        <Col span={8}>
          <DatePicker.RangePicker
            allowClear
            format="YYYY-MM-DD"
            placeholder={['Start Date', 'End Date']}
            onChange={(dates) => {
              const startDate = dates?.[0]?.format('YYYY-MM-DD') || null
              const endDate = dates?.[1]?.format('YYYY-MM-DD') || null
              appendSearchForm({ startDate, endDate })
            }}
          />
        </Col>
        <Col span={4}>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleSearchClick}
            className="btn-primary"
          >
            Search
          </Button>
        </Col>
      </Row>
    </div>
  )
}

TreasureRedeemReportSearch.displayName = 'TreasureRedeemReportSearch'
export default TreasureRedeemReportSearch
